import React, { useRef, useState } from "react";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Input from "@visa/vds/input";
import FormControl from "@visa/vds/form-control";

const MCSFileUpload = (props) => {
  const fileSelector = useRef(null);

  const selectFile = () => {
    fileSelector.current.click();
  };

  return (
    <>
      <div className="vds-file-upload">
        <FormControl position="right" space="seventy">
          <Input
            value={props.fileName && props.fileName}
            label="File"
            name="file-name"
            readOnly
            errorText={props.errorText}
            invalid={props.errorText != ""}
            showErrorText
          />
        </FormControl>
        <FormControl position="right" space="thirty">
          <ButtonGroup>
            <ButtonText onClick={selectFile} colorScheme="secondary">
              Choose File
            </ButtonText>
          </ButtonGroup>
        </FormControl>
        <input
          id={props.id}
          name={props.name}
          accept={props.accept}
          onChange={props.onChange}
          ref={fileSelector}
          type="file"
          style={{ display: "none" }}
        />
      </div>
    </>
  );
};

export default MCSFileUpload;
